import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import MPCResults, { MCResultsProps } from './mpc-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/mortgages/mortgage-payment-calculator`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('mpc') },
    };
  },
};

const MPCResultsWrapper = (props: MCResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={MPCResults}
    />
  );
};

export default MPCResultsWrapper;
